// Raster der Steuerung (Handoff Pille §6): 2 Spalten, Kennzahlen immer volle Breite,
// ein Widget allein in seiner Reihe (vor Kennzahl, Abschnitt oder am Ende) ebenfalls volle Breite.

import { istAbschnitt, type SteuerungsEintrag, type WidgetDef } from './typen';

export type Zeile =
  | { art: 'abschnitt'; titel: string }
  | { art: 'widgets'; widgets: readonly WidgetDef[] };

export function rasterZeilen(eintraege: readonly SteuerungsEintrag[]): Zeile[] {
  const zeilen: Zeile[] = [];
  let offen: WidgetDef | null = null;
  const schliesse = () => { if (offen) { zeilen.push({ art: 'widgets', widgets: [offen] }); offen = null; } };
  for (const e of eintraege) {
    if (istAbschnitt(e)) { schliesse(); zeilen.push({ art: 'abschnitt', titel: e.abschnitt }); continue; }
    if (e.typ === 'kennzahl' || e.voll) { schliesse(); zeilen.push({ art: 'widgets', widgets: [e] }); continue; }
    if (offen) { zeilen.push({ art: 'widgets', widgets: [offen, e] }); offen = null; }
    else offen = e;
  }
  schliesse();
  return zeilen;
}

/** Unterzeile einer Auswahl ohne eigene Angabe */
export function auswahlUnter(wert: string, standard: string | undefined, unter: string | undefined): string {
  if (unter !== undefined) return unter;
  if (standard === undefined) return '';
  return wert === standard ? 'Kein Filter aktiv' : 'Filter aktiv';
}
